import { useResponsiveStyleWrapper } from '@bingads-webui-campaign-react/unified-app-shared';

const getStyles = () => ({
  formContainer: {
    maxWidth: 800,
    '& .advanced-scheduling-grid': {
      width: 'unset !important',

      '& .ad-scheduling-grid': {
        minWidth: 'unset !important',
      },
    },
  },
});

export const useCampaignDetailsStepStyles = () => useResponsiveStyleWrapper(getStyles);
